module.exports = "<p>BRCA Exchange primarily relies on the Hg38 build, though variant aliases from other genome builds are available to users in both views of the data.</p>";


//////////////////
// WEBPACK FOOTER
// ./content/help/research/what-genome-build-is-this-site-using.md
// module id = 1279
// module chunks = 0